import React, { useState, useEffect } from 'react';
import Navbar from "../components/Layouts/Navbar";
import HeroBanner from '../components/Common/HeroBanner';
import Breadcrumb from '../components/Layouts/Breadcrumb';
import OpenPositions from '../components/Careers/OpenPositions';
import Form from '../components/Careers/Form';
import CallBackForm from '../components/Common/CallBackForm'
import WorkWithUs from '../components/Careers/WorkWithUs';
import LifeAtDi from '../components/Careers/LifeAtDi';
import {imageList} from '../components/Careers/DataSet/MainData'
import Footer from '../components/Layouts/Footer';
import Head from 'next/head';
import axios from 'axios'
import * as Yup from 'yup';



const Careers = ({slug = null}) => {


  const options = {
    btn_name: "Submit"
  }

  const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/gif'];
  const FILE_SIZE = 5 * 1024 * 1024; // 5MB

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const fields = [
    {
      name: 'name',
      placeholder: 'Name',
      validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
      className: 'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'lg:col-span-6 col-span-12'
    },
    {
      name: 'email',
      type: 'email',
      placeholder: 'Email',
      validation: Yup.string().email('Invalid email').required('Email is required'),
      className: 'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'lg:col-span-6 col-span-12'
    },
    {
      name: 'job_title',
      placeholder: 'Job Title',
      validation:Yup.string().required('Job Title is required'),
      className: 'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'lg:col-span-6 col-span-12'
    },
    {
      name: 'file_name',
      placeholder: 'Attachments',
      type: 'file',
      className: 'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'lg:col-span-6 col-span-12'
    },
    {
      name: 'message',
      placeholder: 'Message',
      type: 'textarea',
      className: 'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'col-span-12'
    },
  ];

  const [selectedJob, setSelectedJob] = useState([]);

  const CommonComponentMain=()=>{
    return  <div className='border md:p-8 p-4 rounded'>
    <CallBackForm
      fields={fields}
      options={options}
      selectdFields={selectedJob}
      page_name="Careers Page"
      form_name="careers-form"
      endpoint="/enquiry/careers-form"
      slug={slug}
    />
  </div>
  }
  return (
    <>
      
      <Navbar />
      <HeroBanner
        background={process.env.IMG_CDN + "img/banner/careers-banner.png"}
        title={<>DelveInsight Careers</>}
        description={<>We are a leading life science market research and business consulting firm offering
          a wide range of opportunities. If you are looking to build your career, we have the right
          platform for you.
        </>}
      />
      <Breadcrumb />
      <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4">
        <div className="grid grid-cols-12 gap-6">
          <div className="lg:col-span-6 col-span-12">
            <OpenPositions selectField={setSelectedJob} title="Open Positions" shortDescription="DelveInsight offers equal opportunities to everyone regardless of gender, caste, race, and creed. We adhere to equal employment practices." />
          </div>
          <div className="lg:col-span-6 col-span-12">
           <CommonComponentMain/>
          </div>
        </div>
      </div>
      <WorkWithUs title="Why Work with us?" />
      <LifeAtDi title="Life At DelveInsight" data={imageList} />
      <Footer />
    </>
  )
}

Careers.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
      const response = await axios.get(process.env.API_URL + '/meta' + slugData);
      return {
          title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}

export default Careers;
